<template>
  <span
    class="flight-pad-duration"
    :style="{
      'font-size': `${font_size}px`,
    }"
  >
    <span v-if="full">durata</span>
    <span v-if="parse_flight_offers_duration(duration).days">
      {{ parse_flight_offers_duration(duration).days }}g
    </span>
    <span v-if="parse_flight_offers_duration(duration).hours">
      {{ parse_flight_offers_duration(duration).hours }}h
    </span>
    <span v-if="parse_flight_offers_duration(duration).minutes">
      {{ parse_flight_offers_duration(duration).minutes }}m
    </span>
  </span>
</template>

<script>
import { parse_flight_offers_duration } from '@liveflight/utilities/flight-duration';

export default {
  name: 'flight-pad-duration',
  props: {
    duration: String,
    font_size: {
      type: Number,
      default: () => 12,
    },
    full: {
      type: Boolean,
      default: () => false,
    },
  },
  methods: {
    parse_flight_offers_duration,
  },
};
</script>

<style lang="scss" scoped>
.flight-pad-duration {
  font-size: 12px;
}
</style>
